import type { InputProps } from '@lokalise/louis';
import { Input } from '@lokalise/louis';
import { useField } from 'formik';
import { type RefObject } from 'react';

interface InputFieldProps extends Omit<InputProps, 'error'> {
    name: string;
    innerRef?: RefObject<HTMLInputElement>;
}

const InputField = ({ name, innerRef, ...props }: InputFieldProps) => {
    const [field, { touched, error }] = useField({ name, type: props.type ?? 'text' });

    return <Input ref={innerRef} {...field} error={touched ? error : undefined} {...props} />;
};

export default InputField;
